import React from "react"
import { Box } from "@chakra-ui/react"
import { Logger } from "lib/logger"
import type { VariantTrialType } from "types"
import { withErrorBoundary } from "react-error-boundary"
import { TrialResults } from "./TrialResults"
import { RealResults } from "./RealResults"

type Props = {
  trials: VariantTrialType
}

const TrialResultsComponent: React.FC<Props> = ({ trials }) => {
  return (
    <Box>
      <>
        {trials.beforeImage && trials.afterImage ? (
          <RealResults trials={trials} />
        ) : (
          <TrialResults trials={trials} />
        )}
      </>
    </Box>
  )
}

export const TrialResultsWrapper = withErrorBoundary(TrialResultsComponent, {
  fallback: <div />,
  onError(error) {
    Logger.warn(`BeforeAfter failed to load. ${error}`)
  },
})
